/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  permanent address bizo
 */

import { Bizo, PetPolicy, RentHistorySummary, autoclass } from '@zcode/bizos'
import type { PermanentAddressApiResponse, RawPermanentAddressApiResponse } from '@zcode/state-type'
import { Address } from './address'
import { AddressListings } from './address_listings'

const DEFINITION = {
  active: { name: 'active', type: AddressListings },
  address: { name: 'pa', type: Address },
  inactive: { name: 'inactive', type: AddressListings },
  petPolicy: { name: 'pet_policy', type: PetPolicy, isArray: true },
  rentHistory: { name: 'rent_history', type: RentHistorySummary },
} as const

export const PermanentAddress = autoclass<
  PermanentAddressApiResponse,
  RawPermanentAddressApiResponse
>(
  'PermanentAddress',
  class PermanentAddress extends Bizo<
    PermanentAddressApiResponse,
    RawPermanentAddressApiResponse
  > {},
  // @ts-expect-error // TODO: define this bizo correctly
  DEFINITION,
  null
)
